//
//
//
//
export default {
  name: "historyDetail",
  title: "订单详情"
};